/**
 * About "OUR PHILOSOPHY" section. Static markup; the reveals are class-driven
 * (`.fade-in-move-on-scroll` fade-up, `.philosophy-card` fade-zoom) and wired
 * globally by SiteAnimations — no component-specific motion here.
 */
import type { FC } from 'react'

interface PhilosophyCard {
    number: string
    heading: string
    paragraph: string
    paragraphClassName: string
}

const CARDS: PhilosophyCard[] = [
    {
        number: '01',
        heading: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.',
        paragraphClassName: 'card-paragraph'
    },
    {
        number: '02',
        heading: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.',
        paragraphClassName: 'light-text'
    },
    {
        number: '03',
        heading: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
        paragraph: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat. Aenean faucibus nibh et justo cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus tristique posuere.',
        paragraphClassName: 'light-text'
    }
]

export const Philosophy: FC = () => {
    return (
        <div className='section overflow-hidden'>
            <div className='container _6ems'>
                <div className='center-text'>
                    <div className='fade-in-move-on-scroll'>
                        <h1>
                            <span className='accent-text-color'>OUR</span>
                            <br />
                            PHILOSOPHY
                        </h1>
                    </div>
                    <div className='fade-in-move-on-scroll'>
                        <div className='w-layout-grid grid-6-col'>
                            <p id='w-node-_2a3b72ad-ff6e-d2bd-95ee-eb3dff8c2e10-a854ba1a'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Porta feugiat etiam aliquet aliquet tellus vel. Et maecenas id bibendum sit. Augue nulla tortor faucibus nunc.
                            </p>
                        </div>
                    </div>
                </div>
                <div className='our-philosphy-card-holder'>
                    {CARDS.map((card) => (
                        <div key={card.number} className='philosophy-card'>
                            <div className='philosophy-card-left-side'>
                                <h1 className='light-grey-text no-margins'>{card.number}</h1>
                                <h4 className='no-margins'>{card.heading}</h4>
                            </div>
                            <div className='card-break' />
                            <div className='philosophy-card-right-side'>
                                <p className={card.paragraphClassName}>{card.paragraph}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
